
import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from '@services/navigation.service';
import { ITranslationLocale, TranslationService } from '@services/translation.service';
import './languageSelector.component.scss';

@Component({
    selector: "language-selector",
    template: require('./languageSelector.component.html')
})
export class LanguageSelectorComponent implements OnInit {
    @Input() darkText: boolean = false;

    // ---

    locales: ITranslationLocale[] = [];
    selectedLocale: ITranslationLocale;

    constructor(
        private readonly navigationService: NavigationService,
        private readonly translationService: TranslationService) {
    }

    ngOnInit() {
        this.loadCountries().then(() => {
            this.getSelectedLocale();
        });
    }

    setLocale(localeCode: string) {
        const foundLocale = this.locales.find(locale => locale.Locale === localeCode);

        if (!foundLocale) {
            return;
        }

        localStorage.setItem('userSelectedLanguageCode', foundLocale.Locale);

        this.navigationService.reloadAll();
    }

    getSelectedLocale() {
        const foundUserLanguageCode = localStorage.getItem('userSelectedLanguageCode');

        this.selectedLocale = this.locales.find(locale => {
            return (foundUserLanguageCode && foundUserLanguageCode !== "undefined")
                ? locale.Locale == foundUserLanguageCode
                : locale.Locale == "en"
        });

        // Default to english
        if (!this.selectedLocale) {
            this.selectedLocale = this.locales.find(locale => locale.Locale == "en");
        }

        // Occasionally we cannot find english, so just use any language
        if (!this.selectedLocale && this.locales.length) {
            this.selectedLocale = this.locales[0];
        }
    }

    // ---------------------------------------------

    private loadCountries(): angular.IPromise<any> {
        return this.translationService.getListOfLocales().then(locales => {
            this.locales = locales;
            this.selectedLocale = locales.find(l => l.Locale == "en");
        });
    }
}
